<template>
    <div id="book">
        <div class="head-tool">
            <span @click="$router.go(-1)"><i class="el-icon-arrow-left"></i> 返回</span>
            <span class="tc">书籍详情</span>
            <span class="tr" @click="$router.push('/')">首页</span>
        </div>
        <div class="bookinfo" v-if="bookInfo.wid > 0">
            <div class="bookcover fl">
                <img :src="'http://static.yuread.cn/' + bookInfo.h_cover + '!thumb'" alt="">
                <img :src="getFinishimg" alt="" class="finish">
            </div>
            <div class="info fl">
                <p class="title">{{bookInfo.title}}</p>
                <p class="author">{{bookInfo.author}}</p>
                <p class="classify">{{bookInfo.classify}}</p>
                <p class="words">{{bookInfo.word}}字</p>
            </div>
            <el-row :gutter="20" class="btn-g">
                <el-col :span="8">
                    <router-link :to="{name:'Chapter',params:{wid:$route.params.wid,cid:bookInfo.firstChapter.id}}" class="el-button el-button--primary" v-if="!readlog">开始阅读</router-link>
                    <router-link :to="{name:'Chapter',params:{wid:$route.params.wid,cid:readlog}}" class="el-button el-button--primary" v-if="readlog">继续阅读</router-link>

                </el-col>
                <el-col :span="8">
                    <el-button v-if="!collection" @click="doCollection(1)">加入书架</el-button>
                    <el-button v-if="collection"  @click="doCollection(0)">移出书架</el-button>
                </el-col>
                <el-col :span="8">
                    <el-button v-if="!autoSubscribe" @click="doAutoSubscribe(1)">自动订阅</el-button>
                    <el-button v-if="autoSubscribe"  @click="doAutoSubscribe(0)">取消自动订阅</el-button>
                </el-col>
            </el-row>

        </div>
        <el-row :gutter="20" class="d-g">
            <el-col :span="8">
                &nbsp;
                <!--<img src="./../assets/images/dingyue.png" alt="">-->
                <!--<p>订阅</p>-->
            </el-col>
            <el-col :span="8">
                <section @click="doaward">
                    <img src="./../assets/images/dashang.png" alt="">
                    <p>打赏</p>
                </section>

            </el-col>
            <el-col :span="8">
                <!--<img src="./../assets/images/shumi.png" alt="">-->
                <!--<p>书迷</p>-->
            </el-col>
        </el-row>
        <div class="description">
            <p class="desc">{{bookInfo.sort_description}}</p>
        </div>

        <div class="catalog" v-if="lastChapter.id > 0">
            <span>目录</span> <router-link :to="{name:'Catalog',params:{wid:$route.params.wid}}">{{lastChapter.title}}</router-link>  <i class="el-icon-arrow-right" @click="$router.push({name:'Catalog',params:{wid:$route.params.wid}})"></i><span class="time">{{lastChapter.time}}</span>
        </div>
        <div class="currency ">
            <h3>同类精品</h3>
            <ol class="ol-list">
                <li v-for="v in getJingpin">
                    <router-link :to="v.link">
                        <img :src="'http://static.yuread.cn/' + v.img" alt="">
                        <p class="title">{{v.title}}</p>

                    </router-link>
                </li>


            </ol>
        </div>

        <div class="reply">
            <h3>读者评论</h3>
            <div class="input fl">
                <el-input
                        type="textarea"
                        placeholder="请输入评论"
                        v-model="reply"
                        maxlength="2000"
                        show-word-limit
                ></el-input>
            </div>

            <div class="btn fr">
                <img :src="getCover" alt="" :onerror.once="defaultUser">
                <el-button type="primary" size="mini" @click="doReply">发表</el-button>
            </div>

            <ul class="reply-list">
                <li v-for="val in replyList">
                    <div class="fl">
                        <img :src="val.cover" alt="" :onerror.once="defaultUser">
                    </div>

                    <div class="fr">
                        <p class="nickname">{{val.nickname}} <span class="author" v-if="val.uid == bookInfo.author_id">作者</span> <span class="replyBtn" @click="sonReply(val)">回复</span></p>
                        <p class="time">{{val.create_time}}</p>
                        <p class="info" v-html="val.content"></p>
                    </div>
                    <dl v-if="val.son">
                        <dd v-for="item in val.son" >
                            <div class="fl">
                                <img :src="item.cover" alt="" :onerror.once="defaultUser">
                            </div>

                            <div class="fr">
                                <p class="nickname">{{item.nickname}} <span class="author" v-if="item.uid == bookInfo.author_id">作者</span></p>
                                <p class="time">{{item.create_time}}</p>
                                <p class="info" v-html="item.content"></p>
                            </div>
                        </dd>
                    </dl>
                </li>

            </ul>

            <router-link tag="p" class="gd" :to="{name:'Reply',params:{wid:$route.params.wid,author:bookInfo.author_id}}">查看更多 <i class="el-icon-arrow-down"></i></router-link>

        </div>
        <transition name="custom-classes-transition" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
            <div class="award-box" v-if="getUserInfo.id > 0" v-show="award" @click="reward">
                <div class="award" @click.stop>
                    <h4>为幸苦的作者大大打call～</h4>
                    <ul>
                        <li :class="{active:rewardActive == 1}" @click="rewardActive = 1;rewardNum = 188"><a>188书币</a></li>
                        <li :class="{active:rewardActive == 2}" @click="rewardActive = 2;rewardNum = 588"><a>588书币</a></li>
                        <li :class="{active:rewardActive == 3}" @click="rewardActive = 3;rewardNum = 1000"><a>1000书币</a></li>
                        <li :class="{active:rewardActive == 4}" @click="rewardActive = 4;rewardNum = 5000"><a>5000书币</a></li>
                        <li :class="{active:rewardActive == 5}" @click="rewardActive = 5;rewardNum = 10000"><a>10000书币</a></li>
                        <li :class="{active:rewardActive == 6}" @click="rewardActive = 6"><a>其他金额 <input type="number" v-model="rewardNum"> 书币</a></li>
                    </ul>
                    <div class="footer">
                        <div class="fl">
                            余额：<span class="red">{{getUserInfo.money}}</span> 书币 <span class="red">{{getUserInfo.voucher}}</span> 书豆
                        </div>
                        <div class="fr">
                            <span v-show="getUserInfo.money >= rewardNum" @click="doReward">打赏</span>
                            <router-link :to="{name:'Recharge'}" v-show="getUserInfo.money < rewardNum">充值</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "Book",
        data (){
            return {
                defaultUser : 'this.src="'+require('./../assets/images/user.png')+'"',
                reply : '',
                bookInfo : {},
                award : false,
                lastChapter : {},
                jingpin : [],
                autoSubscribe : false,//是否自动订阅
                collection : false,//是否收藏
                readlog : false,
                replyList : [],
                rewardNum : 188,
                rewardActive : 1,
            }
        },
        computed:{
            getFinishimg(){
                if(this.bookInfo.is_finish == 1){
                    return require('./../assets/images/finish1.png')
                }
                return require('./../assets/images/finish0.png')

            },
            getJingpin(){
                let jingpin = [];
                this.jingpin.forEach(v =>{
                    if(v.sex == this.bookInfo.sex){
                        jingpin.push(v);
                    }

                })
                return jingpin;
            },
            getUserInfo(){
                return this.$store.getters.getUserInfo;
            },
            getCover(){
                if(this.getUserInfo.cover.indexOf("http") != -1){
                    return this.getUserInfo.cover;
                }
                return "http://static.yuread.cn/" + this.getUserInfo.cover;
            }
        },
        watch : {
            '$route'(to,from){
                if(to.path != from.path){
                    this.getBookInfo();
                    this.getLastChapter();
                    this.getRecommendList();
                    this.getSubscribeAndCollection();
                    this.getBookReply();
                }
            }
        }
        ,methods : {
            sonReply(obj){
                if(this.getUserInfo.id > 0){
                    this.$prompt('回复 - '+obj.nickname, '提示', {
                        customClass:'replyBox',
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        inputPattern: /\S{3,30}/,
                        inputErrorMessage: '回复内容长度3-30个字'
                    }).then(({ value }) => {
                        this.axios.post("/api/reply/addReply",{
                            bid : this.$route.params.wid,
                            content : value,
                            pid:obj.id,
                        }).then(r => {
                            let data = r.data;
                            if(data.code){
                                this.$message.success(data.msg);
                                this.reply = '';
                                // this.getBookReply();
                            }else{
                                this.$message.error(data.msg);
                            }
                        })
                    }).catch(() => {

                    });
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }

            },
            getBookInfo(){
                this.axios.post('/api/book/book',{
                    bookid : this.$route.params.wid
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                        this.$router.go(-1);
                    }else{
                        this.bookInfo = data.data.bookInfo;
                        this.lastChapter = data.data.lastChapter;
                        this.jingpin = data.data.recommend;
                        this.autoSubscribe = data.data.subscribeAndCollection.subscribe;
                        this.collection = data.data.subscribeAndCollection.collection;
                        this.readlog = data.data.subscribeAndCollection.read;
                        this.replyList = data.data.replyList;
                    }
                })
            },


            doCollection(type){
                if(this.getUserInfo.id > 0){
                    this.axios.post('/api/collection/doCollection',{
                        bid : this.$route.params.wid,
                        type : type,
                    }).then(r =>{
                        let data = r.data;
                        if(data.code == 1){
                            if(type == 1){
                                this.collection = true;
                            }else{
                                this.collection = false;
                            }
                        }
                    })
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            doAutoSubscribe(type){
                if(this.getUserInfo.id > 0){
                    this.axios.post('/api/subscribe/doSubscribe',{
                        bid : this.$route.params.wid,
                        type : type,
                    }).then(r =>{
                        let data = r.data;
                        if(data.code == 1){
                            if(type == 1){
                                this.autoSubscribe = true;
                            }else{
                                this.autoSubscribe = false;
                            }
                        }
                    })
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            doaward(){
                if(this.getUserInfo.id > 0){
                    this.award = true;
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            doReply(){
                if(this.getUserInfo.id > 0){
                    if(this.reply.length < 3){
                        alert("评论内容不能少于3个字");
                    }else{
                        this.axios.post("/api/reply/addReply",{
                            bid : this.$route.params.wid,
                            content : this.reply,
                        }).then(r => {
                            let data = r.data;
                            if(data.code){
                                this.$message.success(data.msg);
                                this.reply = '';
                                // this.getBookReply();
                            }else{
                                this.$message.error(data.msg);
                            }
                        })
                    }
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },

            reward(){
                if(this.getUserInfo.id > 0){
                    this.award = !this.award;
                }else{
                    if(confirm("请先登录后操作！")){
                        this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                    }
                }
            },
            doReward(){
                this.axios.post("/api/reward/doReward",{
                    money : this.rewardNum,
                    bid : this.$route.params.wid,
                }).then(r => {
                    let data = r.data;
                    if(data.code == 0){
                        this.$message.error(data.msg);
                    }else if(data.code == 1){
                        this.award = false;
                        this.$message.success(data.msg);
                        //存储用户信息
                        this.$store.dispatch('setUserInfo',data.data);
                    }
                });
            }
        },created() {
            let book = ['38564','38938'];

            if(document.body.clientWidth > 750 && book.indexOf(this.$route.params.wid) > -1){
                this.$router.push({name:'Tiaozhuan',params:{wid:this.$route.params.wid}});
                return ;
            }
            this.getBookInfo();
        },mounted() {
            var _this = this;

            // _this.getLastChapter();
            // _this.getRecommendList();
            // _this.getSubscribeAndCollection();
            // _this.getBookReply();


            // console.log(this.getUserInfo);
        }
    }
</script>

<style lang="less">
    @import "~animate.css";
    .replyBox{width: 700px !important;
        .el-message-box__title{font-size: 30px;}
        .el-message-box__headerbtn{font-size: 30px;}
        .el-message-box__message{font-size: 26px;}
        .el-input__inner{height: 50px;font-size: 30px;}
        button{font-size: 30px;}
    }
#book{background: #f6f6f7;
    .head-tool{display: flex;padding: 26px 20px;background: #fff;
        span{flex:1;font-size: 30px;color:#333;
            i{font-size: 30px;}
        }
    }
    .bookinfo{background: #fff;padding: 0 20px 20px;overflow: auto;border-bottom: 1px solid #efefef;
        .bookcover{width:170px;height:200px;overflow: hidden;padding-left: 20px;position: relative;
            img{width:100%;height:100%;}
            .finish{position: absolute;top:-6px;left: 18px;width: 80px;height: 80px;}
        }
        .info{padding: 10px 20px;width: 540px;
            .title{font-size: 36px;color:#333;overflow: hidden; text-overflow:ellipsis; white-space: nowrap;}
            .author{font-size: 24px;line-height: 50px;}
            .words,.classify{color: #333;font-size: 24px;line-height: 40px;}

        }
        .btn-g{
            width: 100%;clear: both;padding: 20px 0;
            margin: 0 !important;
            button{width: 100%;}
            span{font-size: 26px;}
            a{width:100%;font-size: 26px;}
        }

    }
    .d-g{background: #fff;
        margin: 0 !important;
        text-align: center;padding: 20px 0;
        img{width:44px;height:48px;}
        p{font-size: 28px;}
    }

    .description{margin-top:20px;background: #fff;padding:20px;font-size: 26px;color:#6e6e6e;border-bottom: 1px solid #efefef;}
    .catalog{padding:20px;background: #fff;
        span{font-size: 26px;}
        a{font-size: 26px;padding-left: 30px;color:#6e6e6e;}
        i{float: right;font-size: 30px;position: relative;top: 5px;}
        .time{float: right;color: #999;}

    }
    .currency {margin-top: 20px;
        padding: 20px;
        background: #fff;
        overflow: auto;

        h3 {
            border-left: 4px solid @theme;
            text-indent: 10px;
            margin-bottom: 20px;
            font-size: 34px;
            span{
                text-indent:0;background: #33373d;color: #fff;font-size: 25px ;text-align: center;border-radius:5px;width: 40px;display: inline-block;
            }
            .day{
                background: @theme;
            }

            a {
                color: #666;
                font-size: 28px;
                float: right;

                i {
                    font-size: 26px;
                }
            }
        }


        .ol-list {
            white-space: nowrap;
            overflow-x: auto;
            overflow-y: hidden;
            padding: 0;
            a{width:100%;}
            li {
                width: 155px;
                margin-right: 30px;
                display: inline-flex;

                img {
                    width: 100%;
                    height: 205px;
                    box-shadow: 0 1PX 3PX rgba(0, 0, 0, .3);
                }

                .title {

                    color: #333;
                    line-height: 30px;
                    font-size: 26px;
                    font-weight: unset;
                    overflow: hidden;
                    white-space: initial;
                    text-overflow: ellipsis;
                }

                .author {
                    color: #8c939d;
                    width: 132px;
                    font-size: 26px;
                    font-weight: unset;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }

        .gender {
            text-align: center;
            line-height: 47px;
            margin-bottom: 20px;
            width: 100%;
            display: flex;

            button {
                flex: 1;
            }


        }
    }

    .reply{background: #fff;margin-top: 20px;padding: 20px;
        h3 {
            border-left: 4px solid @theme;
            text-indent: 10px;
            margin-bottom: 20px;
            font-size: 34px;}

        .input{width:550px;
            textarea{height: 150px;font-size: 30px;-webkit-appearance: none;}
            .el-input__count{font-size: 26px;}
        }
        .btn{width:150px;text-align: center;
            img{width:80px;height:80px;}
            span{font-size: 30px;}
        }

        .reply-list{clear: both;padding: 20px 0;
            li{margin-bottom: 20px;overflow: hidden;border-bottom: 1px solid #efefef;padding-bottom: 20px;

                .author{font-size: 20px;background: @theme;color: #fff;padding: 2px 10px;}
                .fl{width:86px;height: 86px;
                    img{width:86px;height:86px;border-radius: 50%;}

                }
                .fr{width: calc(100% - 120px);color:#686c62;padding-bottom: 20px;
                    .nickname{font-size: 30px;}
                    .time{
                        font-size: 24px;
                    }
                    .info{color:#6e6e6e;font-size: 24px;
                        .sendMoney{color: red;margin: 0 5px;}
                    }
                    .replyBtn{float: right;font-size: 20px;}
                }
                dl{
                    float: right;width: calc(100% - 80px);padding:10px;background: #fafafa;
                    dd{margin-bottom: 10px;overflow: hidden;
                        .fl{
                            width:76px;height: 76px;
                            img{width:76px;height:76px;border-radius: 50%;}
                        }
                        .fr{width: calc(100% - 100px);color:#686c62;border-bottom: 1px solid #efefef;padding-bottom: 20px;
                            .nickname{font-size: 30px;}
                            .time{
                                font-size: 24px;
                            }
                            .info{color:#6e6e6e;font-size: 24px;
                                .sendMoney{color: red;margin: 0 5px;}
                            }
                        }
                    }

                }
            }

        }
        .gd{clear: both;text-align: center;padding: 20px 0 40px;font-size: 24px;color:#333;}
    }

    .award-box{
        position:fixed;top:0;left:0;right: 0;bottom: 0;
        .award{width:100%;position: absolute;bottom: 0;background: #fff;
            h4{color:@theme;font-size: 24px;padding: 20px;border-bottom: 1px solid #efefef;}
            ul{padding: 20px 10px;overflow: hidden;
                li{float: left;width:50%;padding: 0 10px;text-align: center;margin-bottom: 20px;
                    a{border:1px solid #efefef;width:100%;display: inline-block;padding: 20px;border-radius: 10px;font-size: 24px;color:#666;
                        input{width:80px;border:none;border-bottom:1px solid #efefef;}
                        input{width:80px;border:none;border-bottom:1px solid #efefef;}
                    }
                }
                li.active{
                    a{
                        border:1px solid @theme;color: @theme;
                    }
                }
            }
            .footer{overflow: hidden;border-top:1px solid #efefef;height: 100px;line-height: 100px;
                .fl{font-size: 24px;color:#666;padding-left: 20px;}
                .red{color:@theme;}
                .fr{width: 200px;background: @theme;height: 100%;text-align: center;color:#fff;font-size: 24px;}
            }

        }
    }



}
</style>
